import { domQuerySelector } from 'pf-frontend-common/src/helper/dom/query-selector';

import { configGetSettings } from 'common/helper/config/get-settings';
import { BrokerSerpStoreFactory } from 'common/module/broker-serp/store.factory';
import { AbTestService } from 'common/service/ab-test/service';
import { AutocompleteCacheBrokersService } from 'common/service/autocomplete-cache-brokers/service';
import { AutocompleteCacheLocationsDelayedService } from 'common/service/autocomplete-cache-locations/delayed/service';
import { BrokerStoreService } from 'common/service/broker-store/service';
import { FooterService } from 'common/service/footer/service';
import { HeaderService } from 'common/service/header/service';
import { LanguageSelectorService } from 'common/service/language-selector/service';
import { PrivacyPromptService } from 'common/service/privacy-prompt/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';
import { BrokerHomeBundleSettingsInterface } from 'desktop/entry/broker-home/bundle/settings.interface';
import { BrokerHomeViewFactory } from 'desktop/module/broker/home/view.factory';
import { UserAvatarComponent } from 'desktop/module/user/avatar/component';

AbTestService().initialize();

const bundleSettings = configGetSettings<BrokerHomeBundleSettingsInterface>();

// Common services
HeaderService()
  .setComponents({
    UserAvatarComponent,
  })
  .render();
UserAuthenticationService();
FooterService();

LanguageSelectorService();

PrivacyPromptService();

// Initialize store
const brokerStoreService = BrokerStoreService();

brokerStoreService.initialize({
  payload: bundleSettings.broker.payload,
});

// Initialize broker serp store
const brokerSerpStore = BrokerSerpStoreFactory();

brokerSerpStore.initialize({
  searchOutput: brokerStoreService.getSearchOutput(bundleSettings.broker.payload),
});

// Initialize autocomplete cache service
AutocompleteCacheBrokersService().initialize();
AutocompleteCacheLocationsDelayedService();

// Initialize view
const brokerHomeView = BrokerHomeViewFactory(brokerSerpStore);
const element = domQuerySelector(document, '[data-qs="broker-home"]');

brokerHomeView.initialize({
  element,
  subview: {
    searchForm: {
      viewOptions: {
        element: domQuerySelector(element, '[data-qs="search-form"]'),
      },
    },
    autocomplete: {
      viewOptions: {
        element: domQuerySelector(element, '[data-qs="autocomplete"]'),
      },
    },
    brokerList: {
      viewOptions: {
        element: domQuerySelector(element, '[data-qs="broker-list"]'),
      },
    },
    loader: {
      viewOptions: {
        element: domQuerySelector(element, '[data-qs="loader"]'),
      },
    },
  },
});

// Render view
brokerHomeView.render();
